/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { GridApi, RowNode } from 'ag-grid-community';

export class GridRowEvent<T> {
  node: RowNode;
  rowIndex: number;
  data: T;
  context: any;
  api: GridApi;
}

export interface GridSelectedRowChangeEvent<T> {
  id?: any;
  node?: RowNode;
  data?: T;
}
